import { Navigation } from "@/components/Navigation";
import { HeroSection } from "@/components/HeroSection";
import { AboutSection } from "@/components/AboutSection";
import { ServicesSection } from "@/components/ServicesSection";
import { ProcessSection } from "@/components/ProcessSection";
import { ContactSection } from "@/components/ContactSection";
import { Footer } from "@/components/Footer";
import { SmokeCanvas } from "@/components/SmokeCanvas";
import { usePageMeta } from "@/hooks/usePageMeta";

const Index = () => {
  usePageMeta(
    "AiLum Solutions | Tvorba webů, aplikací a AI automatizace",
    "Tvoříme moderní webové stránky, aplikace a AI automatizace pro firmy. Responzivní weby na míru, AI chatboty, školení a digitální řešení, která posouvají váš business."
  );
  // 1. HERO + SERVICES - protáhnout až doprava k pravé straně
  const heroServicesGradient = {
    top: '0vh',
    left: '-15%',
    width: '130%',
    height: '200vh',
  };
  
  // 2. ABOUT - posunout níž a protáhnout doprava
  const aboutGradient = {
    top: 'calc(100vh + 1100px)',
    left: '-15%',
    width: '130%',
    height: '800px',
  };
  
  // 3. CONTACT - z DOLNÍHO LEVÉHO rohu šikmo NAHORU doprava
  const contactGradient = {
    bottom: '100px',
    left: '-15%',
    width: '130%',
    height: '600px',
  };

  return (
    <main className="min-h-screen relative" style={{ overflowX: "clip" }}>
      {/* Layer 1: Base Background - FIXED - PURE BLACK */}
      <div 
        style={{
          position: 'fixed',
          inset: 0,
          backgroundColor: '#000000',
          zIndex: 0
        }}
      />
      
      {/* Layer 8: Vignette - FIXED - PURE BLACK */}
      <div
        style={{
          position: 'fixed',
          inset: 0,
          background: `radial-gradient(ellipse at center,
            transparent 0%,
            transparent 25%,
            rgba(0, 0, 0, 0.4) 50%,
            rgba(0, 0, 0, 0.7) 75%,
            rgba(0, 0, 0, 0.95) 100%
          )`,
          pointerEvents: 'none',
          zIndex: 2
        }}
      />

      {/* Smoke Canvas - interactive cursor effect - z-index 5 */}
      <SmokeCanvas />
      
      {/* Content - z-index 10 */}
      <div className="relative" style={{ zIndex: 10 }}>
        
        {/* Layer 2-7: Gradient Sections - ABSOLUTE (scrolluje s obsahem) */}
        <div style={{ 
          position: 'absolute', 
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          pointerEvents: 'none',
          zIndex: 1
        }}>
          
          {/* === 1. HERO + SERVICES GRADIENT === */}
          
          {/* Cyan Ambient - 30% darker */}
          <div style={{
            position: 'absolute',
            ...heroServicesGradient,
            background: `linear-gradient(45deg,
              transparent 0%,
              transparent 10%,
              rgba(0, 50, 70, 0.15) 10%,
              rgba(0, 70, 100, 0.20) 30%,
              rgba(0, 90, 120, 0.28) 50%,
              rgba(0, 70, 100, 0.20) 50%,
              rgba(0, 50, 70, 0.15) 62%,
              transparent 75%,
              transparent 100%
            )`,
            mixBlendMode: 'screen',
            filter: 'blur(100px)'
          }} />
          
          {/* Main Gradient - 30% darker */}
          <div style={{
            position: 'absolute',
            ...heroServicesGradient,
            background: `linear-gradient(45deg,
              transparent 0%,
              transparent 15%,
              rgba(0, 80, 110, 0.035) 19.6%,
              rgba(0, 120, 160, 0.105) 25.2%,
              rgba(0, 160, 200, 0.175) 31.6%,
              rgba(0, 180, 220, 0.245) 35%,
              rgba(0, 200, 240, 0.28) 38.5%,
              rgba(0, 180, 220, 0.245) 42%,
              rgba(0, 160, 200, 0.245) 45.4%,
              rgba(0, 120, 160, 0.175) 51.8%,
              rgba(0, 80, 110, 0.14) 57.4%,
              transparent 62%,
              transparent 100%
            )`,
            mixBlendMode: 'screen',
            filter: 'blur(60px)'
          }} />

          {/* === 2. ABOUT GRADIENT === */}
          
          {/* Cyan Ambient - 30% darker */}
          <div style={{
            position: 'absolute',
            ...aboutGradient,
            background: `linear-gradient(45deg,
              transparent 0%,
              transparent 10%,
              rgba(0, 50, 70, 0.21) 15%,
              rgba(0, 70, 100, 0.28) 25%,
              rgba(0, 90, 120, 0.315) 35%,
              rgba(0, 70, 100, 0.28) 50%,
              rgba(0, 50, 70, 0.21) 62%,
              transparent 75%,
              transparent 100%
            )`,
            mixBlendMode: 'screen',
            filter: 'blur(100px)'
          }} />
          
          {/* Main Gradient - 30% darker */}
          <div style={{
            position: 'absolute',
            ...aboutGradient,
            background: `linear-gradient(10deg,
              transparent 0%,
              transparent 15%,
              rgba(0, 80, 110, 0.105) 19.6%,
              rgba(0, 120, 160, 0.14) 25.2%,
              rgba(0, 160, 200, 0.175) 31.6%,
              rgba(0, 180, 220, 0.21) 35%,
              rgba(0, 200, 240, 0.21) 38.5%,
              rgba(0, 180, 220, 0.175) 42%,
              rgba(0, 160, 200, 0.14) 45.4%,
              rgba(0, 120, 160, 0.14) 51.8%,
              rgba(0, 80, 110, 0.105) 57.4%,
              transparent 62%,
              transparent 100%
            )`,
            mixBlendMode: 'screen',
            filter: 'blur(60px)'
          }} />

          {/* === 3. CONTACT GRADIENT === */}
          
          {/* Cyan Ambient - 30% darker */}
          <div style={{
            position: 'absolute',
            ...contactGradient,
            background: `linear-gradient(135deg,
              transparent 0%,
              transparent 10%,
              rgba(0, 50, 70, 0.21) 15%,
              rgba(0, 70, 100, 0.28) 25%,
              rgba(0, 90, 120, 0.315) 35%,
              rgba(0, 70, 100, 0.28) 50%,
              rgba(0, 50, 70, 0.21) 62%,
              transparent 75%,
              transparent 100%
            )`,
            mixBlendMode: 'screen',
            filter: 'blur(100px)'
          }} />
          
          {/* Main Gradient - 30% darker */}
          <div style={{
            position: 'absolute',
            ...contactGradient,
            background: `linear-gradient(160deg,
              transparent 0%,
              transparent 15%,
              rgba(0, 80, 110, 0.105) 19.6%,
              rgba(0, 120, 160, 0.14) 25.2%,
              rgba(0, 160, 200, 0.175) 31.6%,
              rgba(0, 180, 220, 0.175) 35%,
              rgba(0, 200, 240, 0.21) 38.5%,
              rgba(0, 180, 220, 0.175) 42%,
              rgba(0, 160, 200, 0.175) 45.4%,
              rgba(0, 120, 160, 0.14) 51.8%,
              rgba(0, 80, 110, 0.105) 57.4%,
              transparent 62%,
              transparent 100%
            )`,
            mixBlendMode: 'screen',
            filter: 'blur(60px)'
          }} />
          
        </div>
        
        <Navigation />
        <HeroSection />
        <ServicesSection />
        <ProcessSection />
        <AboutSection />
        <ContactSection />
        <Footer />
      </div>
    </main>
  );
};

export default Index;